import React, { useEffect, useState } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { Button, Form, Spin, message, Row, Col, Input, Select } from 'antd';
import { ArrowLeftOutlined, SaveOutlined } from '@ant-design/icons';
import axios from '../utils/axios';
import BreadCrumb from '../components/Breadcrumb';

function ManageHomePageAddEdit() {
	const navigate = useNavigate();
	const { editManageHomePageId } = useParams();
	const [isLoading, setIsLoading] = useState(false);
	const [isEventLoading, setEventLoading] = useState(true);
	const [events, setEvents] = useState([]);
	const [selectedEvents, setSelectedEvents] = useState([]);
	const [form] = Form.useForm();

	const getEvents = () => {
		axios
			.get(`/event`, { params: { fields: JSON.stringify(['_id', 'title']) } })
			.then((result) => {
				if (Array.isArray(result.data.data) && result.data.data.length) {
					setEvents(result.data.data);
				}
			})
			.catch(() => {})
			.finally(() => {
				setEventLoading(false);
			});
	};

	const get = () => {
		if (!editManageHomePageId) {
			return;
		}
		axios
			.get(`/manage-home-page`, { params: { _id: editManageHomePageId } })
			.then(({ data }) => {
				if (Array.isArray(data.data) && data.data.length) {
					const eventIds = data.data[0].events.map(({ _id }) => _id);
					form.setFieldsValue({ ...data.data[0], events: eventIds });
					setSelectedEvents(data.data[0].events);
				}
			})
			.catch(() => {})
			.finally(() => {
				setIsLoading(false);
			});
	};

	const onSave = () => {
		form.validateFields()
			.then((values) => {
				setIsLoading(true);
				values.events = selectedEvents;
				if (editManageHomePageId) {
					values._id = editManageHomePageId;
				}
				axios({
					method: editManageHomePageId ? 'put' : 'post',
					url: '/manage-home-page',
					data: values,
				})
					.then((result) => {
						if (result.data.success) {
							message.success(result.data.message);
							navigate('/manage-home-page');
						} else {
							message.error(result.data.message);
							setIsLoading(false);
						}
					})
					.catch(() => {
						message.error('Oops! Something went wrong!');
						setIsLoading(false);
					});
			})
			.catch((e) => {
				console.log(e);
			});
	};

	useEffect(() => {
		getEvents();
		get();
	}, []);

	return (
		<>
			<BreadCrumb
				breadcrumbs={[
					{
						link: '/',
						label: 'Home',
					},
					{
						link: '/manage-home-page',
						label: 'Manage Home Page',
					},
					{
						label: editManageHomePageId ? 'Edit Section' : 'Add Section',
					},
				]}
			/>
			<Spin spinning={isLoading}>
				<div className='main-content'>
					<div className='page-header'>
						<div className='page-title'>{editManageHomePageId ? 'Edit Home Page Section' : 'Add Home Page Section'}</div>
						<div className='page-title-more'>
							<Link to='/manage-home-page'>
								<Button icon={<ArrowLeftOutlined />}>Back</Button>
							</Link>
							<Button icon={<SaveOutlined />} type='primary' onClick={onSave}>
								Save
							</Button>
						</div>
					</div>
					<div className='form-content'>
						<Form form={form} layout='vertical' autoComplete='off'>
							<Row gutter={[16, 0]}>
								<Col sm={24} md={12}>
									<Form.Item
										label='Section Title'
										name='sectionTitle'
										rules={[
											{
												required: true,
												message: 'Section Title is required',
											},
										]}
									>
										<Input placeholder="For e.g. Winter Special, Weekend Trek, Women's Special" autoFocus />
									</Form.Item>
								</Col>
								<Col sm={24} md={12}>
									<Form.Item
										label='Events'
										name='events'
										rules={[
											{
												required: true,
												message: 'Please select Events',
											},
										]}
									>
										<Select
											placeholder='Select Events'
											allowClear
											showArrow
											showSearch
											optionFilterProp='title'
											mode='multiple'
											style={{ width: '100%' }}
											fieldNames={{ label: 'title', value: '_id' }}
											loading={isEventLoading}
											options={events}
											onChange={(value, option) => {
												setSelectedEvents(option);
											}}
										/>
									</Form.Item>
								</Col>
							</Row>
						</Form>
					</div>
				</div>
			</Spin>
		</>
	);
}

export default ManageHomePageAddEdit;
